module.exports = __webpack_public_path__ + "31a6873d5646fd69b2815070915cdc33.png";